var MDB = window.MDB || {};;
(function ($, global) {
    MDB.WidgetEditor = MDB.WidgetEditor || {};
    var WhereFilter = MDB.WidgetEditor.WhereFilter = {};

    // handles the filter section
    var model, container;
    var numericAndDateTypes = ['Int32', 'Int32?', 'Date', 'DateTime'];
    var allConditionTypes = [
        new WhereConditionType('<', 2, numericAndDateTypes),
        new WhereConditionType('<=', 3, numericAndDateTypes),
        new WhereConditionType('=', 4),
        new WhereConditionType('=>', 5, numericAndDateTypes),
        new WhereConditionType('>', 6, numericAndDateTypes),
        new WhereConditionType('BETWEEN', 7, numericAndDateTypes, 2),
        new WhereConditionType('LIKE', 8, ['String']),
        new WhereConditionType('(1+) DASHBOARD FILTER', 9, undefined, 0),
        new WhereConditionType('DASHBOARD FILTER', 13, undefined, 0),
        new WhereConditionType('!=', 10, numericAndDateTypes),
        new WhereConditionType('IS NOT NULL', 11, undefined, 0),
        new WhereConditionType('IS NULL', 12, undefined, 0)
    ];
    var allConditionTypeMap = {};
    allConditionTypes.forEach(function (value) {
        allConditionTypeMap[value.Value] = value;
    });
    WhereFilter.WhereCondition = WhereCondition;
    WhereFilter.AllConditionTypeMap = allConditionTypeMap;

    $.extend(MDB.WidgetEditor.WhereFilter, {
        init: function (whereContainer, widgetModel, autoRender) {
            // model.whereGroups
            container = $(whereContainer);
            model = widgetModel;
            if (autoRender) {
                WhereFilter.render();
            }
        },
        render: function () {
            container.empty();
            var  c = $('<div />');
            for (var i = 0; i < model.whereGroups.length; i++) {
                if (i > 0) {
                    // add or
                    $('<div />', {
                        'class': 'wherefilter-or'
                    }).text(MDB.loadResourceString('ConditionType_Or_Symbol')).appendTo(c);
                }
                WhereFilter.getWhereGroupHtml(model.whereGroups[i], i).appendTo(c);
            }
            if (model.whereGroups.length > 0) {
                // add or
                $('<div />', {
                    'class': 'wherefilter-or'
                }).text(MDB.loadResourceString('ConditionType_Or_Symbol')).appendTo(c);
            }
            // add empty container
            WhereFilter.getWhereGroupHtml([], model.whereGroups.length).appendTo(c);
            c.appendTo(container);

            MDB.WidgetEditor.initFilterDropZone('.wherefilter-condition-dropzone', model);
        },
        getWhereGroupHtml: function (whereGroup, whereGroupIndex) {
            var html;
            var wg = $('<div />', {
                'class': 'wherefilter-group'
            });
            for (var i = 0; i < whereGroup.length; i++) {
                (function () {
                    var entry, wgEntry;
                    entry = whereGroup[i];
                    var attrName = (entry.Source && entry.Source.Name) || '';
                    if (entry.Source && entry.Source.EntityId) {
                        var entity = model.metadata.Entities[entry.Source.EntityId];
                        if (entity) {
                            attrName = entity.Name + '.' + attrName;
                        }
                    }

                    // add columns
                    html = [
                        '<div class="wherefilter-condition">',
                        '  <div class="row">',
                        '     <div class="col-xs-6">',
                        '        <span class="fa fa-trash-o btn-delete" data-iid="', entry._id, '"></span>',
                        '        ', attrName,
                        '     </div>',
                        '     <div class="col-xs-2 smallpadding">',
                        '        <select class="filterType form-control"></select>',
                        '     </div>',
                        '     <div class="between1 col-xs-4 smallpadding">',
                        '         <input type="text" class="value1 form-control" value="" />',
                        '     </div>',
                        '     <div class="between2 col-xs-2 smallpadding">',
                        '         <input type="text" class="value1 form-control" value="" />',
                        '     </div>',
                        '     <div class="between2 col-xs-2 smallpadding">',
                        '         <input type="text" class="value2 form-control" value="" />',
                        '     </div>',
                        '  </div>',
                        '</div>'
                    ].join('');
                    wgEntry = $(html);
                    wgEntry.find('.between2').hide();
                    wgEntry.find('input.value1').val(entry.Value1 || '')
                        .bind('change', function (e) {
                            // multiple fields, so we need to set the value
                            wgEntry.find('input.value1').val(this.value);
                            entry.Value1 = this.value;
                            $('body').trigger('preview-sql');
                        });
                    wgEntry.find('input.value2').val(entry.Value2 || '')
                        .bind('change', function (e) {
                            entry.Value2 = this.value;
                            $('body').trigger('preview-sql');
                        });
                    var filterType = wgEntry.find('.filterType');
                    allConditionTypes.forEach(function (ct) {
                        if (!ct) {
                            return;
                        }
                        $('<option />', {
                            //value: ct.getValue()
                            value: ct.Value
                        }).text(ct.Label).appendTo(filterType);
                    });

                    filterType.val(entry.FilterType);

                    filterType.bind('change', function (e) {
                        var option = $(this).val();
                        entry.FilterType = parseInt(option, 10);
                        var conditions = allConditionTypeMap[option];
                        
                        if (conditions) {
                            if (conditions.MultipleValues) {
                                wgEntry.find('.between1').hide();
                                wgEntry.find('.between2').show();
                            } else if (conditions.NoInputValues) {
                                wgEntry.find('.between2').hide();
                                wgEntry.find('.between1').hide();
                                entry.Value2 = '';
                                wgEntry.find('input.value2').val('');

                            } else {
                                wgEntry.find('.between2').hide();
                                wgEntry.find('.between1').show();
                                entry.Value2 = '';
                                wgEntry.find('input.value2').val('');
                            }
                        }

                        // validate
                        $('body').trigger('preview-sql');
                    }).change();

                    if (entry.Source && entry.Source.EntityId) {
                        WhereFilter.addAutocomplete(wgEntry.find('input.value1, input.value2'),
                            entry.Source.EntityId, attrName.split('.')[1], entry.Source.Type);
                    }
                    wg.append(wgEntry);
                })();
            }
            // add dropzone for new value
            html = [
                '<div class="row">',
                '  <div class="col-xs-12 smallpadding-right">',
                '    <div class="wherefilter-condition-dropzone dropzone" data-groupnr="' + whereGroupIndex + '">',
                '         ' + MDB.loadResourceString('Widget_Edit_DropzoneText_Attribute'),
                '    </div>',
                '  </div>',
                '</div>'
            ].join('');
            wg.append(html);
            //var dz = wg.find('dropzone');

            return wg;
        },
        addAutocomplete: function addAutocomplete(element, entityId, attributeName, type) {
            var source, matcher, ajax = null;
            if (type == 'Boolean' || attributeName == 'Gender') { // Don't need to make an ajax request for these cases.
                source = attributeName == 'Gender' ? ['M', 'F', 'U'] : ['0', '1'];
                matcher = function () {
                    return true; 
                } // Always return the full source array.
            } else {
                ajax = {
                    url: location.origin + '/api/Dashboard/GetAttributeFilterOptions',
                    timeout: 500,
                    triggerLength: 1,
                    loadingClass: 'k-loading',
                    preDispatch: function (query) {
                        return {
                            query: query,
                            entityId: entityId,
                            attributeName: attributeName,
                            divisionId: null
                        }
                    },
                    preProcess: function (data) {
                        if (data.Success === false) {
                            // Hide the list, there was some error
                            return false;
                        }
                        return data.List;
                    }
                };
            }
            element.css('background-position', 'right center');
            element.typeahead({
                source: source,
                ajax: ajax,
                alignWidth: false,
                scrollBar: true,
                matcher: matcher,
                highlighter: function (item) {
                    // Turns off highlighting, as we're only doing the equivalent of String.StartsWith()
                    return item;
                }
            });
        }
    });

    function WhereConditionType(label, value, typeFilter, amountOfInputValues) {
        this.Label = label;
        this.Value = value;
        this.MultipleValues = (amountOfInputValues && amountOfInputValues > 1);
        this.NoInputValues = amountOfInputValues === 0;
        this.TypeFilter = typeFilter || [];
    }

    WhereConditionType.prototype = {
        constructor: WhereConditionType,
        getValue: function () {
            return this.Value;
        },
        valueOf: function () {
            return this.Label;
        },
        toString: function () {
            return this.Label;
        }
    };

    function WhereCondition(attrId, model, entityId) {
        this._id = 'W' + (WhereCondition._idCount++);
        var metadata = model.metadata;
        this.Id = attrId;
        this.entityId = entityId;
        this.Source = metadata.AttributesById[attrId];
        this.Value1 = '';
        this.Value2 = '';
        this.FilterType = 4;
    }

    WhereCondition._idCount = 0;
    WhereCondition.prototype = {
        constructor: WhereCondition,
        Id: null,
        Value1: null,
        Value2: null,
        Source: null,
        FilterType: -1
    };
})(jQuery, window);